import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import PrivateRoute from "./components/PrivateRoute";
import Layout from "./components/Layout";

import Login        from "./pages/Login";
import Onboarding   from "./pages/Onboarding";
import Dashboard    from "./pages/Dashboard";
import Paychecks    from "./pages/Paychecks";
import Bills        from "./pages/Bills";
import SavingsGoals from "./pages/SavingsGoals";
import DebtTracker  from "./pages/DebtTracker";
import CalendarPage from "./pages/Calendar";
import SettingsPage from "./pages/Settings";

function AppRoutes() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login"    element={<Login />} />
      <Route path="/register" element={<Navigate to="/login" replace />} />

      {/* Onboarding (private, no sidebar) */}
      <Route
        path="/onboarding"
        element={
          <PrivateRoute>
            <Onboarding />
          </PrivateRoute>
        }
      />

      {/* Private app (with sidebar layout) */}
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Layout>
              <Routes>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/paychecks" element={<Paychecks />} />
                <Route path="/bills"     element={<Bills />} />
                <Route path="/savings"   element={<SavingsGoals />} />
                <Route path="/debts"     element={<DebtTracker />} />
                <Route path="/calendar"  element={<CalendarPage />} />
                <Route path="/settings"  element={<SettingsPage />} />
                <Route path="*"          element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Layout>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
